import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

function NoEmployees(props: SvgIconProps) {
  return (
    <SvgIcon {...props} height="128" viewBox="0 0 160 128" width="160">
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_3588_102"
          x1="117.629"
          x2="51.7393"
          y1="106.213"
          y2="21.3974"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F4F6FD" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_3588_102"
          x1="105.711"
          x2="80.8436"
          y1="38.8799"
          y2="63.7475"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear_3588_102"
          x1="78.5079"
          x2="37.4815"
          y1="59.8099"
          y2="100.835"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint3_linear_3588_102"
          x1="89.1109"
          x2="71.0912"
          y1="58.917"
          y2="58.917"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint4_linear_3588_102"
          x1="85.3828"
          x2="60.1175"
          y1="39.7751"
          y2="39.7751"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint5_linear_3588_102"
          x1="74.8229"
          x2="74.8229"
          y1="14.7203"
          y2="51.6308"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint6_linear_3588_102"
          x1="55.1091"
          x2="71.1838"
          y1="133.085"
          y2="117.01"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint7_linear_3588_102"
          x1="111.776"
          x2="88.7989"
          y1="132.383"
          y2="109.408"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint8_linear_3588_102"
          x1="53.86"
          x2="104.033"
          y1="74.9315"
          y2="125.106"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <clipPath id="clip0_3588_102">
          <rect fill="white" height="128" width="160" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip0_3588_102)">
        <mask
          height="133"
          id="mask0_3588_102"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
          width="160"
          x="0"
          y="-4"
        >
          <path
            d="M56.4221 2.078C44.6971 7.403 38.3521 23.34 32.6361 36.938C28.8041 46.058 25.2501 54.128 20.5461 57.236C-5.90794 74.721 -2.97794 97.896 8.01106 112.356C14.4081 120.77 25.3051 128.264 37.2811 128.264C45.3991 128.264 54.0131 124.819 62.0571 115.881C82.7201 92.925 96.6071 98.243 110.536 103.562C119.861 107.124 129.206 110.684 140.616 105.76C151.531 101.048 160.137 93.03 159.89 78.538C159.738 69.5 156.14 57.938 147.507 43.094C139.301 28.978 128.547 16.252 115.921 7.661C105.59 0.632996 94.0091 -3.631 81.5351 -3.63C73.5011 -3.63 65.0951 -1.86 56.4221 2.078Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_3588_102)">
          <path
            clipRule="evenodd"
            d="M56.4587 5.53679C44.726 10.7046 38.3768 26.1711 32.6571 39.3676C28.8225 48.2183 25.2662 56.0501 20.5591 59.0663C-5.91231 76.0351 -2.98039 98.5259 8.01585 112.559C14.4171 120.725 25.3212 127.997 37.3051 127.997C45.4285 127.997 54.0481 124.654 62.0974 115.98C82.774 93.7017 96.6702 98.8626 110.608 104.025C119.939 107.481 129.291 110.936 140.708 106.158C151.63 101.585 160.242 93.8036 159.995 79.7394C159.843 70.9683 156.242 59.7476 147.604 45.3419C139.392 31.6426 128.631 19.2923 115.997 10.955C105.659 4.13446 94.0704 -0.00365585 81.5882 -0.00268538C73.549 -0.00268538 65.1374 1.71506 56.4587 5.53679Z"
            fill="url(#paint0_linear_3588_102)"
            fillRule="evenodd"
          />
        </g>
        <mask
          height="36"
          id="mask1_3588_102"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
          width="36"
          x="75"
          y="33"
        >
          <path
            d="M75.6931 51.313C75.6931 61.025 83.5661 68.898 93.2771 68.898C102.989 68.898 110.862 61.025 110.862 51.314C110.861 41.602 102.989 33.729 93.2771 33.729C83.5661 33.729 75.6931 41.603 75.6931 51.314"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_3588_102)">
          <path
            clipRule="evenodd"
            d="M75.6931 51.313C75.6931 61.025 83.5661 68.898 93.2771 68.898C102.989 68.898 110.862 61.025 110.862 51.314C110.861 41.602 102.989 33.729 93.2771 33.729C83.5661 33.729 75.6931 41.603 75.6931 51.314"
            fill="url(#paint1_linear_3588_102)"
            fillRule="evenodd"
          />
        </g>
        <mask
          height="59"
          id="mask2_3588_102"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
          width="60"
          x="28"
          y="51"
        >
          <path
            d="M28.9861 80.323C28.9861 96.344 41.9741 109.332 57.9951 109.332C74.0171 109.332 87.0041 96.344 87.0041 80.322C87.0041 64.302 74.0171 51.313 57.9941 51.313C41.9751 51.313 28.9871 64.302 28.9871 80.323"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_3588_102)">
          <path
            clipRule="evenodd"
            d="M28.9861 80.323C28.9861 96.344 41.9741 109.332 57.9951 109.332C74.0171 109.332 87.0041 96.344 87.0041 80.322C87.0041 64.302 74.0171 51.313 57.9941 51.313C41.9751 51.313 28.9871 64.302 28.9871 80.323"
            fill="url(#paint2_linear_3588_102)"
            fillRule="evenodd"
          />
        </g>
        <mask
          height="20"
          id="mask3_3588_102"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
          width="19"
          x="71"
          y="49"
        >
          <path
            d="M72.9481 55.763C72.9481 55.763 75.2731 61.206 71.0911 63.067L81.6841 68.245L89.1111 63.067C89.1111 63.067 83.8791 58.419 83.0291 49.589L72.9491 55.763H72.9481Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask3_3588_102)">
          <path
            clipRule="evenodd"
            d="M72.9481 55.763C72.9481 55.763 75.2731 61.206 71.0911 63.067L81.6841 68.245L89.1111 63.067C89.1111 63.067 83.8791 58.419 83.0291 49.589L72.9491 55.763H72.9481Z"
            fill="url(#paint3_linear_3588_102)"
            fillRule="evenodd"
          />
        </g>
        <mask
          height="35"
          id="mask4_3588_102"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
          width="26"
          x="60"
          y="22"
        >
          <path
            d="M70.1061 23.361C70.1061 23.361 63.8001 24.712 64.2661 30.444C64.7501 36.364 63.0491 42.479 61.2311 43.82C59.4121 45.16 60.3691 46.5 60.3691 46.5C60.3691 46.5 60.9441 47.642 62.7621 47.457C64.0991 47.32 63.9191 48.391 63.8201 48.808C63.2421 51.227 61.3001 56.99 67.2341 56.576C72.7801 56.189 84.1771 54.183 84.8471 44.228C85.4551 35.204 87.7121 22.954 74.6531 22.953C73.3061 22.953 71.7971 23.083 70.1061 23.361Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask4_3588_102)">
          <path
            clipRule="evenodd"
            d="M70.1061 23.361C70.1061 23.361 63.8001 24.712 64.2661 30.444C64.7501 36.364 63.0491 42.479 61.2311 43.82C59.4121 45.16 60.3691 46.5 60.3691 46.5C60.3691 46.5 60.9441 47.642 62.7621 47.457C64.0991 47.32 63.9191 48.391 63.8201 48.808C63.2421 51.227 61.3001 56.99 67.2341 56.576C72.7801 56.189 84.1771 54.183 84.8471 44.228C85.4551 35.204 87.7121 22.954 74.6531 22.953C73.3061 22.953 71.7971 23.083 70.1061 23.361Z"
            fill="url(#paint4_linear_3588_102)"
            fillRule="evenodd"
          />
        </g>
        <mask
          height="38"
          id="mask5_3588_102"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
          width="38"
          x="56"
          y="14"
        >
          <path
            d="M56.5461 21.733C54.8861 30.413 62.2891 29.136 69.8191 30.029C77.3491 30.923 76.3281 36.411 76.3281 37.304C76.3281 37.304 76.2011 38.454 76.5841 40.495C76.9661 42.537 80.6681 40.623 82.1991 39.857C83.7311 39.091 85.3891 41.261 83.3481 43.558C81.3061 45.856 79.6461 46.238 83.2201 50.705C86.7941 55.172 91.0051 42.537 92.9201 32.837C94.8341 23.137 89.7291 21.988 85.7731 22.244C81.8161 22.499 83.2201 22.882 77.2211 18.032C74.6261 15.934 70.7181 14.72 66.9841 14.72C62.0861 14.719 57.4861 16.809 56.5451 21.733"
            fill="white"
          />
        </mask>
        <g mask="url(#mask5_3588_102)">
          <path
            clipRule="evenodd"
            d="M56.5461 21.733C54.8861 30.413 62.2891 29.136 69.8191 30.029C77.3491 30.923 76.3281 36.411 76.3281 37.304C76.3281 37.304 76.2011 38.454 76.5841 40.495C76.9661 42.537 80.6681 40.623 82.1991 39.857C83.7311 39.091 85.3891 41.261 83.3481 43.558C81.3061 45.856 79.6461 46.238 83.2201 50.705C86.7941 55.172 91.0051 42.537 92.9201 32.837C94.8341 23.137 89.7291 21.988 85.7731 22.244C81.8161 22.499 83.2201 22.882 77.2211 18.032C74.6261 15.934 70.7181 14.72 66.9841 14.72C62.0861 14.719 57.4861 16.809 56.5451 21.733"
            fill="url(#paint5_linear_3588_102)"
            fillRule="evenodd"
          />
        </g>
        <mask
          height="35"
          id="mask6_3588_102"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
          width="10"
          x="51"
          y="90"
        >
          <path
            d="M51.8851 113.672C51.7541 117.26 51.6331 120.922 51.5961 124.447C54.0421 123.084 56.4761 121.323 58.8741 119.113C59.8041 107.948 60.9011 93.203 60.9011 93.203L51.8851 90.34C51.8851 90.34 52.3251 101.708 51.8851 113.672Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask6_3588_102)">
          <path
            clipRule="evenodd"
            d="M51.8851 113.672C51.7541 117.26 51.6331 120.922 51.5961 124.447C54.0421 123.084 56.4761 121.323 58.8741 119.113C59.8041 107.948 60.9011 93.203 60.9011 93.203L51.8851 90.34C51.8851 90.34 52.3251 101.708 51.8851 113.672Z"
            fill="url(#paint6_linear_3588_102)"
            fillRule="evenodd"
          />
        </g>
        <mask
          height="13"
          id="mask7_3588_102"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
          width="10"
          x="98"
          y="90"
        >
          <path
            d="M98.7201 93.203L99.3721 99.867C102.144 100.511 104.849 101.433 107.539 102.43C107.537 95.453 107.735 90.34 107.735 90.34L98.7191 93.203H98.7201Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask7_3588_102)">
          <path
            clipRule="evenodd"
            d="M98.7201 93.203L99.3721 99.867C102.144 100.511 104.849 101.433 107.539 102.43C107.537 95.453 107.735 90.34 107.735 90.34L98.7191 93.203H98.7201Z"
            fill="url(#paint7_linear_3588_102)"
            fillRule="evenodd"
          />
        </g>
        <mask
          height="59"
          id="mask8_3588_102"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
          width="61"
          x="49"
          y="61"
        >
          <path
            d="M80.1001 65.094C74.7291 65.161 71.0901 63.067 71.0901 63.067C63.8511 65.211 58.6881 66.617 55.6421 72.652C51.9911 79.885 49.4171 89.886 49.4171 89.886L60.0891 93.332L58.5131 119.441C59.755 118.317 60.9376 117.13 62.0561 115.883C77.5401 98.679 89.2201 97.353 99.9621 100.008L99.4221 93.158L109.652 89.856C109.652 89.856 107.964 79.857 104.559 72.652C101.67 66.54 95.3251 64.122 88.0851 61.979C88.0851 61.979 85.4711 65.161 80.0991 65.094"
            fill="white"
          />
        </mask>
        <g mask="url(#mask8_3588_102)">
          <path
            clipRule="evenodd"
            d="M80.1001 65.094C74.7291 65.161 71.0901 63.067 71.0901 63.067C63.8511 65.211 58.6881 66.617 55.6421 72.652C51.9911 79.885 49.4171 89.886 49.4171 89.886L60.0891 93.332L58.5131 119.441C59.755 118.317 60.9376 117.13 62.0561 115.883C77.5401 98.679 89.2201 97.353 99.9621 100.008L99.4221 93.158L109.652 89.856C109.652 89.856 107.964 79.857 104.559 72.652C101.67 66.54 95.3251 64.122 88.0851 61.979C88.0851 61.979 85.4711 65.161 80.0991 65.094"
            fill="url(#paint8_linear_3588_102)"
            fillRule="evenodd"
          />
        </g>
      </g>
    </SvgIcon>
  )
}

export default NoEmployees
